module.exports = __webpack_public_path__ + "img/logo.11bbf36b.png";